export default {
      id: "predicta-modal-right-arrow-usage",
      viewBox: "0 0 19 14",
      url: "/" + "images/icons.3.109.2.svg#predicta-modal-right-arrow-usage",
      toString: function () {
        return this.url;
      }
    }